import SubmittedProposalsReportTypes from "./submittedProposalsReport.types";

export const submittedProposalsReportFetchStart = (
  submittedProposalsReportList: any,
) => ({
  type: SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_FETCH_START,
  payload: submittedProposalsReportList,
});

export const submittedProposalsReportFetchSuccess = (success: any) => ({
  type: SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_FETCH_SUCCESS,
  payload: success,
});

export const submittedProposalsReportFetchFailure = (failure: any) => ({
  type: SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_FETCH_FAILURE,
  payload: failure,
});

export const submittedProposalsReportFetchResetStart = () => ({
  type: SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_FETCH_RESET_START,
});

export const submittedProposalsReportFetchResponseChanged = () => ({
  type: SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_FETCH_RESPONSE_CHANGED,
});

//*******EXPORT SUBMITTED PROPOSALS REPORT********* */
export const submittedProposalsReportExportAllStart = (
  submittedProposalsReportList: any,
) => ({
  type: SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_EXPORT_START,
  payload: submittedProposalsReportList,
});

export const submittedProposalsReportExportAllSuccess = (success: any) => ({
  type: SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_EXPORT_SUCCESS,
  payload: success,
});

export const submittedProposalsReportExportAllFailure = (failure: any) => ({
  type: SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_EXPORT_FAILURE,
  payload: failure,
});

export const submittedProposalsReportExportAllReset = () => ({
  type: SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_EXPORT_CHANGED,
});

export const submittedProposalsReportExportAllChanged = () => ({
  type: SubmittedProposalsReportTypes.SUBMITTED_PROPOSALS_REPORT_EXPORT_RESET_START,
});
